import React, { useState } from "react";
// No framer-motion
import { AiOutlineCheck } from "react-icons/ai";
import AllTab from "../../assets/All-Tab.svg";
import { useTranslation } from "react-i18next";
import { MdExpandCircleDown } from "react-icons/md";

const features = [
  {
    id: 1,
    title: "Automated Image Annotation",
    desc: "Our AI instantly tags and classifies every detected issue — turning drone imagery into actionable insights without manual review.",
  },
  {
    id: 2,
    title: "Cost Estimate Engine",
    desc: "Automatically estimate repair costs with AI-driven precision, saving time and reducing human error.",
  },
  {
    id: 3,
    title: "Real-Time Status Tracking",
    desc: "Track inspections, repair progress, and approvals in real-time on one centralized platform.",
  },
  {
    id: 4,
    title: "Data Storage & Retrieval",
    desc: "Easily store, retrieve, and share property inspection data securely whenever you need.",
  },
  {
    id: 5,
    title: "Accurate Damage Detection",
    desc: "AI models detect damages with high accuracy, ensuring no issue goes unnoticed.",
  },
  {
    id: 6,
    title: "Secure Contractor Marketplace",
    desc: "Connect with verified contractors directly through the platform for seamless repair workflows.",
  },
  {
    id: 7,
    title: "End-to-End Workflow Management",
    desc: "Manage inspections, approvals, contractors, and reporting in one streamlined ecosystem.",
  },
];

const FeaturesSection = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState(1);
  const features = t("featuresSection.features", { returnObjects: true });

  return (
    <section className="bg-gradient-to-b from-green-50 via-white to-[#f7f9fd] py-20 px-6 md:px-12 lg:pl-24 lg:pr-0">
      <div className="w-full grid md:grid-cols-2 gap-12 items-start">
        {/* Left Side: Features List */}
        <div>
          <h2 className="font-arya text-3xl md:text-4xl font-bold mb-8">
            {t("featuresSection.heading.part1")}{" "}
            <span className="text-[#2E6243]">{t("featuresSection.heading.part2")}</span>
          </h2>

          <div className="space-y-4">
            {features.map((feature) => (
              <div
                key={feature.id}
                onClick={() => setActive(active === feature.id ? null : feature.id)}
                className={`cursor-pointer bg-white rounded-xl border-2 transition overflow-hidden ${
                  active === feature.id ? "shadow-lg" : "shadow-sm"
                } py-6 px-6 md:py-8 md:px-8`}
              >
                {/* Row header */}
                <div className="flex items-center justify-between">
                  {/* Image/Icon */}
                  <div className="flex items-center gap-3">
                    <span
                      className={`font-semibold text-lg md:text-xl ${
                        active === feature.id ? "text-[#2E6243]" : "text-gray-800"
                      }`}
                    >
                      {String(feature.id).padStart(2, "0")}. {feature.title}
                    </span>
                  </div>

                  {/* Arrow */}
                  <MdExpandCircleDown
                    size={28}
                    className={`text-xl transform transition-transform ${
                      active === feature.id ? "text-[#2E6243] rotate-180" : "text-gray-300"
                    }`}
                  />
                </div>

                {/* Expanding description inside the same row (CSS only) */}
                <div
                  className={`feature-desc px-4 text-base md:text-lg text-gray-600 overflow-hidden transition-[max-height,padding,opacity] duration-700`}
                  style={{
                    maxHeight: active === feature.id ? 600 : 0,
                    opacity: active === feature.id ? 1 : 0.2,
                    paddingBottom: active === feature.id ? 16 : 0,
                    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  {feature.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side: Constant Mockup Collage */}
        <div className="relative flex justify-end h-full lg:pr-0">
          {/* Large Desktop Mockup */}
          <div className="sticky top-20 w-full max-w-xl flex justify-end">
            <img
              src={AllTab}
              alt="Desktop Mockup"
              className="rounded-lg w-full max-w-xl object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
